import AddProductIcon from '#assets/svg/add-product.svg?component';
import CompetitorVisionIcon from '#assets/svg/competitor-vision.svg?component';
import MoneyIcon from '#assets/svg/money.svg?component';
import { config } from '#config/configuration';
import { getDocumentationURL } from '#domain/core/documentation/documentation.query';
import { routes } from '#router/routes';
import { type MenuDataType as C4MenuData } from '@c4-links/vue3-links-components';
import type { AvailableLanguagesType } from '@carrefour-gcs/shared';
import { markRaw } from 'vue';
import StoreIcon from './components/StoreIcon.vue';

export async function getSideBarData(lang: AvailableLanguagesType): Promise<C4MenuData[]> {
  const documentationURL = await getDocumentationURL(lang, false);

  return [
    {
      id: 'performance',
      name: 'performance',
      path: routes.performance.path,
      icon: 'home'
    },
    {
      id: 'zoomPages',
      path: null,
      selected: false,
      icon: null,
      name: 'zoomPages',
      childSection: [
        {
          id: 'sales-amount',
          path: routes.detail('sales-amount').path,
          name: 'sales-amount',
          icon: markRaw(MoneyIcon)
        },
        {
          id: 'sales-quantity',
          path: routes.detail('sales-quantity').path,
          name: 'sales-quantity',
          icon: 'grid'
        },
        {
          id: 'business-equation',
          path: routes.businessEquation.path,
          name: 'business-equation',
          icon: 'divide'
        },
        {
          id: 'possession-rate',
          path: routes.detail('possession-rate').path,
          name: 'possession-rate',
          icon: markRaw(StoreIcon)
        },
        {
          id: 'dn-dv',
          path: routes.detail('dn-dv').path,
          name: 'dn-dv',
          icon: 'move'
        }
      ]
    },
    {
      id: 'competitor',
      path: null,
      selected: false,
      icon: null,
      name: 'competitor',
      childSection: [
        {
          id: 'competitor-vision',
          path: routes.competitor.vision.path,
          name: 'competitor-vision',
          icon: markRaw(CompetitorVisionIcon)
        }
      ]
    },
    {
      id: 'client',
      path: null,
      selected: false,
      icon: null,
      name: 'client',
      childSection: [
        {
          id: 'dynamic-client',
          path: routes.detail('dynamic-client').path,
          name: 'dynamic-client',
          icon: 'award'
        },
        {
          id: 'customer-segmentation',
          path: routes.customerSegmentation.path,
          name: 'customer-segmentation',
          icon: 'users'
        }
      ]
    },
    {
      id: 'toolsSection',
      path: null,
      selected: false,
      icon: null,
      name: 'toolsSection',
      childSection: [
        {
          id: 'projects',
          name: 'projects',
          path: routes.projects.list.path,
          icon: 'clipboard'
        },
        {
          id: 'innovations',
          name: 'innovations',
          path: '#',
          icon: markRaw(AddProductIcon)
        },
        {
          id: 'tools',
          path: routes.tools.path,
          name: 'tools',
          icon: 'link'
        }
      ]
    },
    {
      id: 'ressources',
      path: null,
      selected: false,
      icon: null,
      name: 'ressources',
      childSection: [
        {
          id: 'settings',
          path: routes.settings.home.path,
          name: 'settings',
          icon: 'settings'
        },
        {
          id: 'documentation',
          path: documentationURL,
          name: 'documentation',
          icon: 'info',
          isNewTab: true
        },
        {
          id: 'support',
          path: '#',
          name: 'support',
          icon: 'help-circle'
        }
      ]
    },
    {
      id: 'accessManagement',
      path: null,
      selected: false,
      icon: null,
      name: 'accessManagement',
      childSection: [
        {
          id: 'accountManagement',
          path: routes.admin.account.path,
          name: 'accountManagement',
          icon: 'users'
        }
      ]
    }
  ];
}

export async function getAdminSideBarData(lang: AvailableLanguagesType): Promise<C4MenuData[]> {
  const documentationURL = await getDocumentationURL(lang, false);

  return [
    {
      id: 'administration',
      path: null,
      selected: false,
      icon: null,
      name: 'administration',
      childSection: [
        {
          id: 'administration',
          path: routes.admin.home.path,
          name: 'administration',
          icon: 'tool'
        }
      ]
    },
    {
      id: 'accessManagement',
      path: null,
      selected: false,
      icon: null,
      name: 'accessManagement',
      childSection: [
        {
          id: 'organizationsManagementList',
          path: routes.admin.organizationsManagementList.path,
          name: 'organizationsManagementList',
          icon: 'shield'
        },
        {
          icon: 'settings',
          id: 'permissionsManagement',
          name: 'permissionsManagement',
          path: routes.admin.permissionsManagement.path,
          hidden:
            !config.newPermissionsManagementFeatureEnabled || config.newPermissionsManagementFeatureEnabled === 'false' // TODO: Remove me when permission management feature is ready
        }
      ]
    },
    {
      id: 'ressources',
      path: null,
      selected: false,
      icon: null,
      name: 'ressources',
      childSection: [
        {
          id: 'documentation',
          path: documentationURL,
          name: 'documentation',
          icon: 'info',
          isNewTab: true
        },
        {
          id: 'usageTracking',
          path: routes.admin.usageTracking.path,
          name: 'usageTracking',
          icon: 'download'
        }
      ]
    }
  ];
}
